export default {"src":"/_next/static/media/location_pin.be3752ba.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};